import React from "react";
import Navbar from "../../components/navBarLanding";
import Portada from "../../components/Portada";
import WhyChooseUs from "../../components/whychoosecomponent";
import CleaningServices from "../../components/Cleaningservices";
import Cleaninsolution from "../../components/Cleaningsolution";
import Galery from "../../components/galery";
import Faq from "../../components/Faq";
import Contact from "../../components/Contactus";
import Footer from "../../components/Footer";

const HomePage: React.FC = () => {
  return (
    <>
      <Navbar />
      <Portada />
      <WhyChooseUs />
      <CleaningServices />
      <Cleaninsolution />
      <Galery />
      <Faq />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
